import { useContext } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, DashboardModule, Link,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'
import type { DefaultContext } from '@contexts/pageContext'

import type { PageContextPayload } from '@sections/Admin/packs/Projects/screens/Detail/screens/TaskDetail'

import type { TaskListItemModel } from '@models/taskListItem'

import useAttachment from '@hooks/useAttachment'
import useAttachments from '@hooks/useAttachments'

import AttachmentListItem from '@components/AttachmentListItem'

interface AssetsProps {
  taskListItem: TaskListItemModel,
}

const Assets = (props: AssetsProps) => {
  const { taskListItem } = props

  const pageContext = useContext<DefaultContext<PageContextPayload>>(PageContext)
  const {
    callbacks: {
      deleteAttachment,
    },
  } = pageContext

  const attachmentsPayload = useAttachments({
    filters: {
      attachable_type: 'TaskListItem',
      attachable_id: taskListItem.id,
    },
    performHttpRequests: !!taskListItem.id,
  })

  const {
    filteredAttachments,
    hasFilteredAttachments,
    loading,
  } = attachmentsPayload

  // Task List Attachments
  const taskListAttachmentPayload = useAttachment({
    attachable_type: 'TaskList',
    attachable_id: taskListItem.task_list_id,
  })

  const {
    callbacks: { uploadAttachment: uploadTaskListAttachment },
  } = taskListAttachmentPayload

  // Task List Item Attachments
  const taskAttachmentPayload = useAttachment({
    attachable_type: 'TaskListItem',
    attachable_id: taskListItem.id,
  })

  const {
    callbacks: { uploadAttachment: uploadTaskListItemAttachment },
  } = taskAttachmentPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={(
        <Link onClick={() => uploadTaskListAttachment({ hideUploadZone: true })} textProps={{ fontSize: 'small' }}>
          Project Assets
        </Link>
      )}
      title="Task Assets"
    >
      <Box flexDirection="column">
        {filteredAttachments.map(attachment => (
          <AttachmentListItem attachment={attachment} callbacks={{ deleteAttachment }} key={attachment.id} />
        ))}
      </Box>

      <DashboardModule.Footer boxProps={{ borderTop: loading || !hasFilteredAttachments ? 'none' : '1px solid' }}>
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => uploadTaskListItemAttachment()}
          marginLeft="auto"
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Upload Task Asset
        </Button>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

export default Assets
